import { useQuery } from "@tanstack/react-query"
import { routes } from "@nova-ai/shared"

import { apiFetch } from "../lib/api"
import type { ExchangeRates } from "../lib/money"

/** Current EUR-base exchange rates. The backend caches the upstream source for
 *  ~12h, so a long staleTime here is fine — rates only move ~once a day. */
export function useRates() {
  return useQuery({
    queryKey: ["exchange-rates"] as const,
    queryFn: async () => {
      const result = await apiFetch<ExchangeRates>(routes.rates.list())
      if (!result.ok) {
        throw new Error(result.error.message)
      }
      return result.value
    },
    staleTime: 60 * 60 * 1000,
  })
}
